
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { MapPin } from 'lucide-react';

interface MapboxTokenInputProps {
  token: string;
  onTokenChange: (token: string) => void;
  onSubmit: () => void;
}

export const MapboxTokenInput = ({ token, onTokenChange, onSubmit }: MapboxTokenInputProps) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (token.trim()) {
      // حفظ رمز Mapbox في التخزين المحلي
      localStorage.setItem('mapbox_access_token', token.trim());
      
      // لضمان الحفظ تماماً
      if (localStorage.getItem('mapbox_access_token') === token.trim()) {
        onSubmit();
      }
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MapPin className="w-5 h-5" />
          إعداد الخريطة
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="mapbox-token" className="block text-sm font-medium mb-2">
              Mapbox Access Token
            </label>
            <Input
              id="mapbox-token"
              type="password"
              value={token}
              onChange={(e) => onTokenChange(e.target.value)}
              placeholder="أدخل Mapbox Access Token"
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              يمكنك الحصول على المفتاح من{' '}
              <a 
                href="https://mapbox.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                mapbox.com
              </a>
            </p>
          </div>
          <Button type="submit" className="w-full">
            تفعيل الخريطة
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
